module.exports = __webpack_public_path__ + "img/gamebackground.9aac276c.jpg";